import { render, staticRenderFns } from "./lrDepartmentSelect.vue?vue&type=template&id=28bf0520&"
import script from "./lrDepartmentSelect.vue?vue&type=script&lang=js&"
export * from "./lrDepartmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports